<template>
    <IFAList></IFAList>

    <button class="btn btn-secondary mt-4" @click="emit('back')">Back</button>
</template>

<script setup lang="ts">
import IFAList from '../common/IFA/IFAList.vue';

const emit = defineEmits<{(e: 'back'): void;}>();
</script>